Jelly.Actions.Restrict_Characters = function(Parameters) {
	// https://stackoverflow.com/a/22708940/1087275

	console.log(Parameters.Key_Event.keyCode);

	// Allow: backspace, delete, tab, escape and enter
	if ($.inArray(Parameters.Key_Event.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
       // Allow: Ctrl+A
	  (Parameters.Key_Event.keyCode == 65 && Parameters.Key_Event.ctrlKey === true) || 
	   // Allow: home, end, left, right
	  (Parameters.Key_Event.keyCode >= 35 && Parameters.Key_Event.keyCode <= 39)
	) {
	   // let it happen, don't do anything
	   return;
  }

  // https://stackoverflow.com/a/2500638/1087275
 	var charCode = (Parameters.Key_Event.which) ? Parameters.Key_Event.which : window.event.keyCode;  

  var keyChar = String.fromCharCode(charCode); 
  var re = Parameters.Restrict_Characters_Regex;

  console.log(Parameters.Key_Event);
 	console.log(charCode);
 	console.log(keyChar);
 	console.log(re.test(keyChar));

  return re.test(keyChar);
};